module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/our_services_3-52d4ee2dd28fb50fcc8f067e00418d51.jpg";